import React, { useEffect, useState } from "react";
import { useAssessment } from "./hooks/useAssessment";
import WidgetWrapper from "components/WidgetWrapper";
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  useMediaQuery,
} from "@mui/material";

import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import FilterAltOutlined from "@mui/icons-material/FilterAltOutlined";
import AssessmentForm from "./components/assessmentForm";
import AssessmentReports from "./components/assessmentReports";

function Assessment() {
  const {
    open,
    editMode,
    currentAssessment,
    handleOpen,
    handleClose,
    setOpen,
    isLargeScreen,
    isPrinciplesGraph,
  } = useAssessment();

  const isXLFilters = useMediaQuery("(min-width:1800px)");
  const isSmallScreen = useMediaQuery("(max-width:1200px)");
  const [filtersOpen, setFiltersOpen] = useState(isXLFilters);

  useEffect(() => {
    setFiltersOpen(isXLFilters);
  }, [isXLFilters]);

  return (
    <Box m={isLargeScreen ? "1rem" : "1.5rem 0.5rem 2rem 0.5rem"}>
      <WidgetWrapper>
        <FlexBetween>
          <Header
            title={
              isPrinciplesGraph ? "T&L Principles Graph" : "T&L Foci Graph"
            }
            subtitle="View and record lesson visits"
          />
          <Box display="flex" alignItems="center" gap={1}>
            {!isXLFilters && (
              <Button
                startIcon={<FilterAltOutlined />}
                onClick={() => setFiltersOpen((prev) => !prev)}
                variant="outlined"
                size={isSmallScreen ? "small" : "medium"}
                sx={{
                  borderRadius: "6px",
                  fontSize: isSmallScreen ? "11px" : "12px",
                  padding: isSmallScreen ? "6px 10px" : "8px 12px",
                  minHeight: isSmallScreen ? "34px" : "40px",
                }}
              >
                {filtersOpen ? "Hide Filters" : "Show Filters"}
              </Button>
            )}
            <Button
              variant="contained"
              color="primary"
              size={isSmallScreen ? "small" : "medium"}
              sx={{
                borderRadius: "6px",
                fontSize: isSmallScreen ? "11px" : "12px",
                padding: isSmallScreen ? "6px 10px" : "8px 12px",
                minHeight: isSmallScreen ? "34px" : "40px",
                boxShadow: "none",
              }}
              onClick={handleOpen}
            >
              <AssessmentOutlinedIcon sx={{ mr: "0.5rem" }} />
              Record a Lesson Visit
            </Button>
          </Box>
        </FlexBetween>

        <AssessmentReports
          isPrinciplesGraph={isPrinciplesGraph}
          filtersOpen={filtersOpen}
          setFiltersOpen={setFiltersOpen}
          isXLFilters={isXLFilters}
        />
      </WidgetWrapper>

      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>
          {editMode ? `Edit Assessment` : "Create a New Assessment"}
        </DialogTitle>
        <DialogContent>
          <AssessmentForm
            editMode={editMode}
            currentAssessment={currentAssessment}
            setOpen={setOpen}
            handleClose={handleClose}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export default Assessment;
